import type { FC } from "react";
import { useState, useEffect } from "react";

interface NoChangesInfoProps {
  number: number;
}

export const NoChangesInfo: FC<NoChangesInfoProps> = ({ number = 100 }) => {
  const [runTime, setRunTime] = useState(0);
  const [emoji, setEmoji] = useState<string | null>(null);

  // Runtime tracker for emoji changes
  useEffect(() => {
    const timer = setInterval(() => {
      setRunTime((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Update emoji based on runtime
  useEffect(() => {
    if (runTime >= 40) {
      setEmoji("🏔️");
    } else if (runTime >= 30) {
      setEmoji("🌴");
    } else if (runTime >= 20) {
      setEmoji("⛵️");
    } else if (runTime >= 10) {
      setEmoji("🛩️");
    } else if (runTime >= 5) {
      setEmoji("🏄");
    }
  }, [runTime]);

  const textColor = `#39FF14`;

  return (
    <div className="flex flex-col items-center px-4 py-16 text-center">
      <img src={"/logo-1.svg"} width={160} alt="RenewMap Logo icon" />
      <h1 className="my-4 mb-2 text-xl font-bold">
        You have done all there is to do.
      </h1>
      <div
        className="my-4 flex gap-3 text-4xl font-bold"
        style={{ color: textColor }}
      >
        <div className="my-2 text-3xl">{emoji}</div>
        {number.toFixed(2)}
        <div className="my-2 text-3xl">{emoji}</div>
      </div>
      <p className="mb-2 text-gray-500">Why not take a break?</p>
    </div>
  );
};

export default NoChangesInfo;
